/* eslint-disable no-use-before-define */
import React from 'react'
import { show, openWindow} from '../twd'
import Icons from './icons'

export default () => {
    return <React.Fragment>
        <div className="card card-primary purple-top">
        <div className="card-body">

        <div className="row text-center">
            {Icons.dollarIcon}
        <h2>Add fixed income positions to access this report</h2>
        </div>

        <div className="row vertical-offset-sm">
        <div className="col-md-12">
            View market data, performance reports, and income
            outlook of fixed income positions in your portfolio.
        </div>
        </div>

        <div className="row vertical-offset-xs">
        <div className="col-md-12 text-center">
            <button className="btn btn-lg btn-primary-outline"
            onClick={() => {
                openWindow("https://us.etrade.com/knowledge/library/bonds-cds")
            }}
            >Knowledge Library</button>
        </div>
        </div>

        <div className="row ">
        <div className="col-md-12 text-center">
            <button className="btn btn-lg btn-primary-outline"
            onClick={() => {
                show('advanced-screener')
            }}
            >Advanced Screener</button>
        </div>
        </div>

        </div>
        </div>
    </React.Fragment>
}


// WEBPACK FOOTER //
// ./src/portfolio-report/no-account.js